const constants = {
  ACTIONS: {
    POST_WA_OTP_SUCCESS: "POST_WA_OTP_SUCCESS",
    POST_WA_OTP_FAILED: "POST_WA_OTP_FAILED",
    POST_WA_OTP_VERIFY_SUCCESS: "POST_WA_OTP_VERIFY_SUCCESS",
    POST_WA_OTP_VERIFY_FAILED: "POST_WA_OTP_VERIFY_FAILED",
    POST_LEAD_USER_SUCCESS: "POST_LEAD_USER_SUCCESS",
    POST_LEAD_USER_FAILED: "POST_LEAD_USER_FAILED",
    GET_REDO_FAQ:"GET_REDO_FAQ",
    GET_REDO_FAQ_FAILED:"GET_REDO_FAQ_FAILED",
    GET_REDO_PACKAGES:"GET_REDO_PACKAGES",
    GET_REDO_PACKAGES_FAILED:"GET_REDO_PACKAGES_FAILED",
    REDO_OTP_VERIFY_SUCCESS:"REDO_OTP_VERIFY_SUCCESS",
    REDO_OTP_VERIFY_FAILED:"REDO_OTP_VERIFY_FAILED",
    WHATSAPP_OTP_RESPONSE:"WHATSAPP_OTP_RESPONSE",
    CLEAR_OTP_RES:"CLEAR_OTP_RES",
  },
};
export default constants;
